export default __webpack_public_path__ + "static/char-thumb-01-f59f9939e9dc1bd4d8faf2b992cb17d6.png";